import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Fruits.css'; // Import the CSS file for animation styles
import HeaderSection from '../../components/HeaderSection';
import Sidebar from '../../components/SideBar';
import { API_URL } from '../../url/api';

interface Slide {
  id: number;
  image: string;
  audio: string;
  label: string;
  order: number;
  slideshow: number;
}

const Fruits: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [slides, setSlides] = useState<Slide[]>([]);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const response = await axios.get<Slide[]>(API_URL+'slides/');
        setSlides(response.data);
      } catch (error) {
        console.error('Error fetching slides:', error);
      }
    };

    fetchSlides();
  }, []);

  const handleImageClick = () => {
    if (slides.length > 0) {
      const audio = new Audio(slides[currentSlide].audio);
      audio.play();
      setIsPlaying(true);

      audio.addEventListener('ended', () => {
        setIsPlaying(false);
        setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
      });
    }
  };

  return (
    <div>
      <HeaderSection />
    <div className="flex flex-col items-center justify-center h-screen">
      
      <h1 className="text-2xl font-bold mb-8">Fruit Game</h1>
      {
        slides.length > 0 && (
          <p className="text-lg mb-4">
            {slides[currentSlide].label}
          </p>
        )
      }
      <p className="text-black text-xs font-bold text-center">{currentSlide + 1} / {slides.length}</p>
      <br />
      <br />
      <div className="w-96 h-4 bg-gray-200 rounded-lg overflow-hidden">
        <div className="h-full bg-green-500 items-center justify-center" style={{ width: `${(currentSlide / slides.length) * 100}%` }}>
          
        </div>
      </div>
      {slides.length > 0 ? (
        <div className="w-full flex items-center justify-center">
          <img
            ref={React.createRef()}
            src={slides[currentSlide].image}
            alt="Fruit"
            width={300}
            height={300}
            className={`object-contain cursor-pointer ${isPlaying ? 'zoom-in-out' : ''}`}
            onClick={handleImageClick}
          />
          
        </div>
      ) : (
        <p>Loading slides...</p>
      )}
    </div>
    </div>
  );
};

export default Fruits;